export default __webpack_public_path__ + "static/media/veth2.c9d3eeb5.svg";